import styles from "./IlluProject.module.css";

export function IlluProject() {
  return (
    <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
      <g>
        <path
          className={styles.cls1}
          d="M242.68,67.27c-.54,1.97-1.29,3.8-2.21,5.5,0,0-.01,0-.03.04-1.24,2.28-2.91,4.1-4.54,5.96-3.75,4.26-7.48,10.66-7.71,13.19-.43,4.39-20.58,3.31-23.78-6.58,0,0,2.12-2.3.84-16.29h0c-.82-3.77-.74-7.92.41-12.06,3.31-11.98,14.28-19.4,24.52-16.57,10.22,2.83,15.83,14.82,12.51,26.81Z"
        />
        <path
          className={styles.cls1}
          d="M213.93,89.9s2.41-1.37,1.28-11.49-1.4-17.29.49-20.57,7.31-2.06,6.91.67c-.4,2.73-1.85,6.14-3.54,6.18-2.5.07-2.24-8.64,6.74-8.92,8.98-.27,4.12,10.29,1.47,9-1.12-.54-1.45-4.13,3.27-1.76,3.61,1.81-13.23,18.27-12.49,27.9l-4.13-1.01Z"
        />
        <path
          className={styles.cls1}
          d="M229.52,92.17c-.12.44-.38.82-.74,1.15-2.01,1.81-7.42,2.06-13.35.42-5.92-1.64-10.44-4.63-11.24-7.22-.14-.47-.16-.93-.04-1.37s.38-.83.76-1.17c.16.53.49,1.06.94,1.62,1.77,2.11,5.59,4.27,10.28,5.57,4.7,1.3,9.09,1.41,11.69.5.67-.25,1.23-.54,1.64-.9.15.49.18.95.05,1.4Z"
        />
        <path
          className={styles.cls1}
          d="M228.34,96.45c-.78,2.81-7.08,3.51-14.09,1.57s-12.06-5.77-11.28-8.59c.12-.44.37-.81.74-1.14.8,2.59,5.32,5.58,11.24,7.22,5.93,1.64,11.34,1.39,13.35-.42.14.47.16.92.04,1.36Z"
        />
        <path
          className={styles.cls1}
          d="M227.55,99.29c-.12.44-.38.82-.74,1.15-2.01,1.81-7.42,2.06-13.35.42-5.92-1.64-10.44-4.63-11.24-7.22-.14-.47-.16-.93-.04-1.37s.38-.83.76-1.17c.16.53.49,1.06.94,1.62,1.77,2.11,5.59,4.27,10.28,5.57,4.7,1.3,9.09,1.41,11.69.5.67-.25,1.23-.54,1.64-.9.15.49.18.95.05,1.4Z"
        />
        <path
          className={styles.cls1}
          d="M209.58,99.26h7.44v2.35c0,1.12-.91,2.03-2.03,2.03h-3.38c-1.12,0-2.03-.91-2.03-2.03v-2.35h0Z"
          transform="translate(34.75 -53.18) rotate(15.46)"
        />
      </g>
      <path
        className={styles.cls1}
        d="M69.68,260.58h-3.51c-8.28,0-15-6.72-15-15V35.37c0-8.28,6.72-15,15-15h134.95c8.28,0,15,6.72,15,15v7.31"
      />
      <path className={styles.cls1} d="M215.78,248.75c.22-1.02.34-2.08.34-3.17V90.75" />
      <path
        className={styles.cls4}
        d="M120.66,37.35h67.96c5.81,0,10.53,4.72,10.53,10.53v.78c0,5.81-4.72,10.53-10.53,10.53h-67.96v-21.84h0Z"
      />
      <g>
        <path
          className={styles.cls3}
          d="M110.52,37.35v60.07h-4.04v-5.37c0-5.07-2.05-9.65-5.37-12.97-1.35-1.35-2.91-2.49-4.62-3.36,3.78-2.63,6.25-7.01,6.25-11.96,0-8.06-6.54-14.59-14.6-14.59s-14.59,6.53-14.59,14.59c0,4.95,2.47,9.33,6.24,11.96-5.93,3.03-9.99,9.21-9.99,16.33v5.37h-4.05v-60.07h44.77Z"
        />
        <path
          className={styles.cls1}
          d="M106.48,92.05v5.37h-36.68v-5.37c0-7.12,4.06-13.3,9.99-16.33-3.77-2.63-6.24-7.01-6.24-11.96,0-8.06,6.53-14.59,14.59-14.59s14.6,6.53,14.6,14.59c0,4.95-2.47,9.33-6.25,11.96,1.71.87,3.27,2.01,4.62,3.36,3.32,3.32,5.37,7.9,5.37,12.97Z"
        />
      </g>
      <g>
        <path
          className={styles.cls2}
          d="M186.5,116.88h8.4c1.18,0,2.13.96,2.13,2.13v6.26c0,1.18-.96,2.13-2.13,2.13h-8.4v-10.53h0Z"
        />
        <path
          className={styles.cls2}
          d="M186.5,130.91h8.4c1.18,0,2.13.96,2.13,2.13v6.26c0,1.18-.96,2.13-2.13,2.13h-8.4v-10.53h0Z"
        />
        <path
          className={styles.cls2}
          d="M186.5,144.93h8.4c1.18,0,2.13.96,2.13,2.13v6.26c0,1.18-.96,2.13-2.13,2.13h-8.4v-10.53h0Z"
        />
      </g>
      <g>
        <path
          className={styles.cls2}
          d="M186.5,198.96h8.4c1.18,0,2.13.96,2.13,2.13v6.26c0,1.18-.96,2.13-2.13,2.13h-8.4v-10.53h0Z"
        />
        <path
          className={styles.cls2}
          d="M186.5,212.99h8.4c1.18,0,2.13.96,2.13,2.13v6.26c0,1.18-.96,2.13-2.13,2.13h-8.4v-10.53h0Z"
        />
        <path
          className={styles.cls2}
          d="M186.5,227.01h8.4c1.18,0,2.13.96,2.13,2.13v6.26c0,1.18-.96,2.13-2.13,2.13h-8.4v-10.53h0Z"
        />
      </g>
      <line className={styles.cls2} x1="65.75" y1="114.47" x2="121.41" y2="114.47" />
      <line className={styles.cls2} x1="65.75" y1="123.15" x2="121.41" y2="123.15" />
      <line className={styles.cls2} x1="65.75" y1="131.83" x2="121.41" y2="131.83" />
      <line className={styles.cls2} x1="65.75" y1="140.51" x2="121.41" y2="140.51" />
      <line className={styles.cls2} x1="65.75" y1="149.19" x2="121.41" y2="149.19" />
      <line className={styles.cls2} x1="65.75" y1="157.87" x2="121.41" y2="157.87" />
      <line className={styles.cls2} x1="64.9" y1="171.09" x2="178.18" y2="171.09" />
      <line className={styles.cls2} x1="64.9" y1="179.29" x2="178.18" y2="179.29" />
      <line className={styles.cls2} x1="64.9" y1="187.49" x2="178.18" y2="187.49" />
      <line className={styles.cls2} x1="120.66" y1="69.85" x2="146.95" y2="69.85" />
      <line className={styles.cls2} x1="120.66" y1="77.75" x2="166.18" y2="77.75" />
      <line className={styles.cls2} x1="120.66" y1="86.46" x2="166.18" y2="86.46" />
      <line className={styles.cls2} x1="120.66" y1="95.17" x2="166.18" y2="95.17" />
      <g>
        <line className={styles.cls2} x1="129.85" y1="114.47" x2="178.18" y2="114.47" />
        <line className={styles.cls2} x1="129.85" y1="123.15" x2="178.18" y2="123.15" />
        <line className={styles.cls2} x1="129.85" y1="131.83" x2="178.18" y2="131.83" />
        <line className={styles.cls2} x1="129.85" y1="140.51" x2="178.18" y2="140.51" />
        <line className={styles.cls2} x1="129.85" y1="149.19" x2="178.18" y2="149.19" />
        <line className={styles.cls2} x1="129.85" y1="157.87" x2="178.18" y2="157.87" />
      </g>
      <rect className={styles.cls2} x="66.28" y="198.96" width="110.6" height="45.19" />
      <g>
        <line className={styles.cls2} x1="77.11" y1="198.96" x2="77.11" y2="244.15" />
        <line className={styles.cls2} x1="86.99" y1="198.96" x2="86.99" y2="244.15" />
        <line className={styles.cls2} x1="96.87" y1="198.96" x2="96.87" y2="244.15" />
        <line className={styles.cls2} x1="106.75" y1="198.96" x2="106.75" y2="244.15" />
        <line className={styles.cls2} x1="116.63" y1="198.96" x2="116.63" y2="244.15" />
        <line className={styles.cls2} x1="126.51" y1="198.96" x2="126.51" y2="244.15" />
        <line className={styles.cls2} x1="136.4" y1="198.96" x2="136.4" y2="244.15" />
        <line className={styles.cls2} x1="146.28" y1="198.96" x2="146.28" y2="244.15" />
        <line className={styles.cls2} x1="156.16" y1="198.96" x2="156.16" y2="244.15" />
        <line className={styles.cls2} x1="166.04" y1="198.96" x2="166.04" y2="244.15" />
      </g>
      <polyline
        className={styles.cls2}
        points="65.75 242.7 83.07 216.61 92.39 230.45 103.37 220.1 112.82 229.66 159.67 207.72"
      />
      <polyline className={styles.cls2} points="190.71 202.66 192.82 205.67 201.69 195.14" />
      <polyline className={styles.cls2} points="191.13 216.13 193.24 219.14 202.11 208.61" />
      <polyline className={styles.cls2} points="190.71 134.93 192.82 137.94 201.69 127.41" />
      <path
        className={styles.cls3}
        d="M176.87,279.4c-40.73,2.38-99.76-14.98-99.76-14.98-3.96-1.4-6.36-2.68-7.43-3.84h131.44c7.19,0,13.21-5.07,14.66-11.83,10.82.7,26.25,2.79,31.78,8.96,8.85,9.87-29.96,19.3-70.69,21.69Z"
      />
    </svg>
  );
}
